/**
 * Shared formatting utilities for dates and times
 */

/**
 * Format seconds as mm:ss (e.g., "2:30")
 * Used in: DailyPuzzle, PlayPuzzle, ResultsModal
 */
export const formatTime = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

/**
 * Format seconds as human-readable time (e.g., "1h 15m", "2m 30s", "45s")
 * Used in: MyPuzzles
 */
export const formatTimeHuman = (totalSeconds) => {
  if (!totalSeconds || totalSeconds === 0) return '0s';

  const seconds = Math.floor(totalSeconds);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);

  if (hours > 0) {
    const remainingMinutes = minutes % 60;
    return remainingMinutes > 0 ? `${hours}h ${remainingMinutes}m` : `${hours}h`;
  }
  if (minutes > 0) {
    const remainingSeconds = seconds % 60;
    return remainingSeconds > 0 ? `${minutes}m ${remainingSeconds}s` : `${minutes}m`;
  }
  return `${seconds}s`;
};

/**
 * Get date string in YYYY-MM-DD format (local timezone)
 * Used in: DailyPuzzle, dailyPuzzleApi
 */
export const getLocalDateString = (date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Get ordinal suffix for a number (1st, 2nd, 3rd, etc.)
 * Used in: PlayPuzzle, ResultsModal for room rankings
 */
export const getOrdinal = (n) => {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};
